import React, { memo } from "react";
import { HiOutlineArrowLeft } from "react-icons/hi";

interface BackButtonProps {
  onClick: () => void;
  label: string;
}

const BackButton: React.FC<BackButtonProps> = memo(({ onClick, label }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center justify-center w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 text-white hover:scale-105 transition-all duration-200"
    title={label}
  >
    <HiOutlineArrowLeft className="w-4 h-4" />
  </button>
));

BackButton.displayName = "BackButton";

export default BackButton;
